import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ProgressSlot = ({ name }) =>
  <ProgressSlotWrapper />


ProgressSlot.propTypes = {
  name: PropTypes.string
}

ProgressSlot.type = 'ProgressSlot'

export default ProgressSlot

const ProgressSlotWrapper = styled.div`
  text-align: center;

  > img {
    max-width: 100%;
  }
`
